var _defs, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHecm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1242.2 371.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #003b5c;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ff7f32;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.9,86.6h58.5v79h75.1v-79h58.5v211h-58.5v-80.2h-75.1v80.2h-58.5V86.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.2,86.6h169.7v49.4h-111.8v32.3h101.3v46.1h-101.3v33.5h113.3v49.7h-171.2V86.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M899.5,301.8c-15.1,0-29.2-2.7-42.5-8.1-13.3-5.4-24.8-13-34.5-22.8-9.7-9.7-17.5-21.3-23.2-34.7-5.7-13.4-8.6-27.9-8.6-43.6v-.6c0-15.3,2.8-29.6,8.3-43,5.5-13.4,13.3-25,23.2-35,9.9-9.9,21.7-17.7,35.1-23.4,13.5-5.6,28.2-8.4,44.3-8.4s20.7,1.1,29.5,3.2c8.8,2.1,16.9,5.1,24.3,9,7.3,3.9,14,8.5,19.9,13.9,5.9,5.3,11.2,11.2,15.8,17.6l-44,34.1c-6-7.4-12.7-13.4-19.9-17.9-7.2-4.5-16-6.8-26.2-6.8s-14.2,1.5-20.3,4.4c-6.1,2.9-11.4,6.9-15.8,12.1-4.4,5.1-7.9,11.1-10.4,17.9-2.5,6.8-3.8,14.1-3.8,21.7v.6c0,7.8,1.3,15.2,3.8,22.2,2.5,6.9,6,12.9,10.4,17.9,4.4,5,9.7,9,15.8,11.9,6.1,2.9,12.9,4.4,20.3,4.4s10.4-.6,14.9-1.8c4.5-1.2,8.6-3,12.4-5.3,3.7-2.3,7.2-5,10.6-8.1,3.3-3.1,6.6-6.6,9.8-10.4l44,31.3c-5,6.8-10.5,13.2-16.4,19-5.9,5.8-12.7,10.9-20.2,15.1-7.5,4.2-15.9,7.5-25.2,9.9-9.2,2.4-19.7,3.6-31.4,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1017.9,86.6h61.8l50.3,81.7,50.3-81.7h61.8v211h-58.2v-121.2l-54,82.6h-1.2l-53.7-82.3v120.9h-57.3V86.6Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "291.4 84.9 291.4 228.2 145.7 143.3 145.7 0 291.4 84.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 228.2 0 371.5 145.7 286.6 145.7 143.3 0 228.2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHecm);
export default __webpack_public_path__ + "static/media/hecm.96059221fe7d71423070aa2784524d1c.svg";
export { ForwardRef as ReactComponent };